import React, { useState, useEffect } from "react";
import {
  Divider,
  Tabs,
  Popover,
  Button,
  Input,
  Form,
  Modal,
  Table,
  message,
  Popconfirm,
} from "antd";
import "./usersSetting.less";
import { axiosPost } from "@/server/index";
import common from "@/public/common";
import { getCookieNew } from "@/public/utils";
const FormItem = Form.Item;
const { TabPane } = Tabs;

const UsersSetting = (props) => {
  const [currentRoleData, setCurrentRoleData] = useState({});
  const [addUserVisible, setAddUserVisible] = useState(false);
  const [allSelectedRows, setAllSelectedRows] = useState([]);
  const [allSelectedRowKeys, setAllSelectedRowKeys] = useState([]);
  const [hasSelectedRows, setHasSelectedRows] = useState([]);
  const [getUserListReqData, setGetUserListReqData] = useState({
    name: "",
    roleid: "",
    supplierCompanyCode: getCookieNew("supplier_company_code") || "",
    poSubjectCode: getCookieNew("po_subject_code") || "",
  });
  const [addUserListReqData, setAddUserListReqData] = useState({
    name: "",
    roleid: "",
    supplierCompanyCode: getCookieNew("supplier_company_code") || "",
    poSubjectCode: getCookieNew("po_subject_code") || "",
  });
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [roleList, setRoleList] = useState([]);
  const [addroleList, setAddroleList] = useState([]);
  const [hasAddlistLoading, setHasAddlistLoading] = useState(false);
  const [awaitAddloading, setAwaitAddloading] = useState(false);
  const [locale, setLocale] = useState({
    emptyText: "请先搜索出想要添加的用户",
  });

  useEffect(() => {
    let info = props.location.state.fromDashboard;
    if (info) {
      setCurrentRoleData(info);
      setGetUserListReqData((prev) => ({
        ...prev,
        roleid: info.roleid,
      }));
    }
  }, []);

  useEffect(() => {
    if (currentRoleData.roleid) {
      getUserList();
    }
  }, [currentRoleData]);

  // 获取用户列表
  const getUserList = () => {
    setHasAddlistLoading(true);
    axiosPost(common.eurekaUrlDic + "/permission/role/queryuser", {
      ...getUserListReqData,
      roleRange: "include",
    }).then((res) => {
      if (res.status === 200) {
        setRoleList(res.data);
        setHasAddlistLoading(false);
      }
    });
  };

  // 搜索用户名
  const handleInputChange = (e) => {
    setGetUserListReqData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // 查询
  const handleSearch = () => {
    getUserList();
  };

  // 删除用户
  const handleDelUser = (text) => {
    const reqData = {
      roleid: currentRoleData.roleid,
      userid: text.userid,
    };
    axiosPost(
      common.eurekaUrlDic + "/permission/role/deleteuser",
      reqData,
    ).then((res) => {
      if (res.status == 200) {
        message.success("用户删除成功");
        getUserList();
      } else {
        message.error("用户删除失败");
      }
    });
  };

  // 表格-操作
  const handleOption = (text) => {
    return (
      <Popconfirm
        title="确认删除?"
        onConfirm={() => {
          handleDelUser(text);
        }}
        onCancel={() => {
          hadleDelCancel();
        }}
        okText="删除"
        cancelText="取消"
      >
        <span style={{ color: "#1890ff", cursor: "pointer" }}>删除</span>
      </Popconfirm>
    );
  };

  // 取消删除
  const hadleDelCancel = () => {};

  // table-处理状态
  const handleStatus = (text) => {
    let statusArr = ["启用", "停用"];
    return <span>{statusArr[text.status]}</span>;
  };

  // table-角色列表
  const handleRolelist = (text) => {
    let str = text.rolename;
    return (
      <Popover content={str} title={null} trigger="hover">
        <div
          style={{
            maxWidth: "230px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            cursor: "pointer",
          }}
        >
          {str}
        </div>
      </Popover>
    );
  };

  // tab切换
  const currentTabChange = (value) => {
    setCurrentTabIndex(value);
  };

  // 添加用户-打开弹窗
  const openAddRoleModal = () => {
    const info = props.location.state.fromDashboard;
    setAddUserListReqData((prev) => ({
      ...prev,
      roleid: info.roleid,
    }));
    setAddUserVisible(true);
  };

  // 添加用户-搜索
  const handleAddInputChange = (e) => {
    setAddUserListReqData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // 添加用户-查询
  const handleAddSearch = () => {
    if (!addUserListReqData.name.trim()) {
      message.warn("请输入用户名/真实姓名");
      return;
    }
    setAwaitAddloading(true);
    axiosPost(common.eurekaUrlDic + "/permission/role/queryuser", {
      ...addUserListReqData,
      roleRange: "exclude",
    }).then((res) => {
      if (res.status === 200) {
        if (!res.data.length) {
          setLocale((prev) => ({
            ...prev,
            emptyText: "暂无该用户",
          }));
        } else {
          setLocale((prev) => ({
            ...prev,
            emptyText: "请先搜索出想要添加的用户",
          }));
        }
        setAddroleList(res.data);
        setAwaitAddloading(false);
      }
    });
  };

  // 添加用户-取消按钮/关闭弹窗
  const handleAddUserCancel = () => {
    setAddUserVisible(false);
    setAllSelectedRows([]);
    setAllSelectedRowKeys([]);
    setHasSelectedRows([]);
    setAddroleList([]);
    setAddUserListReqData({
      name: "",
      roleid: "",
      supplierCompanyCode: getCookieNew("supplier_company_code") || "",
      poSubjectCode: getCookieNew("po_subject_code") || "",
    });
    setCurrentTabIndex(0);
  };

  // 添加用户-提交按钮
  const handlAddUsereOk = () => {
    let userInfo = getCookieNew("adminName")
      ? JSON.parse(getCookieNew("adminName"))
      : JSON.parse(localStorage.getItem("otheradminName"));
    console.log(props);
    let { roleType } = props.location.state.item || {};
    const reqData = {
      roleid: currentRoleData.roleid,
      userids: allSelectedRowKeys,
      modifyname: userInfo.account,
      poSubjectCode: getCookieNew("po_subject_code") || "",
      businessId: getCookieNew("businessId") || "",
      businessName: getCookieNew("business_name") || "",
      supplierCode: getCookieNew("supplier_code") || "",
      supplierCompanyCode: getCookieNew("supplier_company_code") || "",
      supplierCompanyCode: getCookieNew("supplier_company_code") || "",
    };
    axiosPost(common.eurekaUrlDic + "/permission/role/setuser", reqData).then(
      (res) => {
        if (res.status === 200) {
          getUserList();
          message.success("添加成功");
          handleAddUserCancel();
        }
      },
    );
  };

  // 添加用户-选择用户
  const onAllSelectChange = (allSelectedRowKeys, allSelectedRows) => {
    setAllSelectedRowKeys(allSelectedRowKeys);
    setAllSelectedRows(allSelectedRows);
    let copAllSelectedRows = JSON.parse(JSON.stringify(allSelectedRows));
    for (let i = 0; i < hasSelectedRows.length; i++) {
      for (let k = 0; k < copAllSelectedRows.length; k++) {
        if (copAllSelectedRows[k].userid === hasSelectedRows[i].userid) {
          copAllSelectedRows.splice(k, 1);
        }
      }
    }
    const newHasSelectedRows = [...hasSelectedRows, ...copAllSelectedRows];
    setHasSelectedRows(newHasSelectedRows);
  };

  // 添加用户-逆向选择用户
  const onHasSelectChange = (allSelectedRowKeys, hasSelectedRows) => {
    setAllSelectedRowKeys(allSelectedRowKeys);
  };

  const roleColumns = [
    {
      title: "用户名",
      dataIndex: "username",
      key: "username",
      width: 200,
    },
    {
      title: "真实姓名",
      key: "reallyname",
      dataIndex: "reallyname",
      width: 200,
    },
    {
      title: "角色",
      key: "rolelist",
      width: 300,
      render: (text) => {
        return handleRolelist(text);
      },
    },
    {
      title: "状态",
      key: "status",
      width: 200,
      render: (text) => {
        return text.status == "1" ? "启用" : "停用";
      },
    },
    {
      title: "操作",
      key: "option",
      width: 200,
      render: (text) => {
        return handleOption(text);
      },
    },
  ];

  const modalTabAll = [
    {
      title: "用户名",
      dataIndex: "username",
      key: "username",
      width: 200,
    },
    {
      title: "真实姓名",
      dataIndex: "reallyname",
      key: "reallyname",
      width: 200,
    },
  ];

  const allRowSelection = {
    selectedRows: allSelectedRows,
    selectedRowKeys: allSelectedRowKeys,
    onChange: onAllSelectChange,
  };

  const hasRowSelection = {
    selectedRows: hasSelectedRows,
    selectedRowKeys: allSelectedRowKeys,
    onChange: onHasSelectChange,
  };

  return (
    <div className="usersSetting_wrap">
      {currentRoleData.rolename ? (
        <div>
          <div className="body">
            <div className="content">
              <div className="title">设置用户</div>
              <Divider />
              <p>
                你正在为角色
                <span style={{ color: "#1890ff" }}>
                  {" "}
                  {currentRoleData.rolename}{" "}
                </span>
                设置用户：
              </p>
              <FormItem>
                <div className="item">
                  <span>用户名/真实名称：</span>
                  <Input
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    placeholder="请输入用户名/真实姓名"
                    name="name"
                    className="input"
                  />
                  <Button
                    shape="round"
                    onClick={() => {
                      handleSearch();
                    }}
                    type="primary"
                    style={{ marginLeft: 10 }}
                  >
                    查询
                  </Button>
                </div>
              </FormItem>
              <FormItem>
                <Button
                  shape="round"
                  onClick={() => {
                    openAddRoleModal();
                  }}
                  type="primary"
                >
                  添加用户
                </Button>
              </FormItem>
              <FormItem>
                <Table
                  scroll={{ y: 600 }}
                  loading={hasAddlistLoading}
                  columns={roleColumns}
                  dataSource={roleList}
                  pagination={false}
                  bordered={false}
                  rowKey={(record) => record.userid}
                />
              </FormItem>
            </div>
          </div>
          <Modal
            title="添加用户"
            open={addUserVisible}
            onOk={handlAddUsereOk}
            onCancel={handleAddUserCancel}
            footer={[
              <Button shape="round" type="primary" onClick={handlAddUsereOk}>
                确认
              </Button>,
              <Button shape="round" onClick={handleAddUserCancel}>
                取消
              </Button>,
            ]}
            className="addUser_wrap"
            destroyOnClose={true}
            width={800}
          >
            {currentTabIndex == 0 ? (
              <FormItem>
                <div className="item">
                  <span>用户名/真实名称：</span>
                  <Input
                    onChange={(e) => {
                      handleAddInputChange(e);
                    }}
                    placeholder="请输入用户名/真实姓名"
                    name="name"
                    className="input"
                  />
                  <Button
                    shape="round"
                    onClick={() => {
                      handleAddSearch();
                    }}
                    type="primary"
                    style={{ marginLeft: 10 }}
                  >
                    查询
                  </Button>
                </div>
              </FormItem>
            ) : null}
            <Tabs
              onChange={(value) => {
                currentTabChange(value);
              }}
              type="card"
            >
              <TabPane tab="全部" key="0">
                <Table
                  loading={awaitAddloading}
                  locale={locale}
                  scroll={{ y: 440 }}
                  rowSelection={allRowSelection}
                  rowKey={(record) => record.userid}
                  columns={modalTabAll}
                  dataSource={addroleList}
                  pagination={false}
                  bordered={false}
                />
              </TabPane>
              <TabPane
                tab={"已选择" + "(" + allSelectedRowKeys.length + ")"}
                key="1"
              >
                <Table
                  rowSelection={hasRowSelection}
                  scroll={{ y: 440 }}
                  locale={{ emptyText: "请左侧Tab选择出想要添加的用户" }}
                  rowKey={(record) => record.userid}
                  columns={modalTabAll}
                  dataSource={hasSelectedRows}
                  pagination={false}
                  bordered={false}
                />
              </TabPane>
            </Tabs>
          </Modal>
        </div>
      ) : null}
    </div>
  );
};

export default UsersSetting;



// WEBPACK FOOTER //
// ./src/pages/roleManagement/usersSetting.js